/**
 * 是否保留路由
 * return true保留 false去除
 */
export const handleKeepRoute = (route, userRole) => {
  const role = (route.meta && route.meta.role) || []
  if (role.length === 0) {
    return true
  }
  // userRole: 1-租户 2-诊所代理人
  return role.indexOf(userRole) > -1
}

/**
 * 管理端路由(租户和操作者路由基本一致)
 * role
 * 0 租户管理员
 * 1 诊所代理人
 */
export const manageRoutes = [{
  name: 'Layout',
  path: '/layout/index',
  children: [
    // 首页
    {name: 'Home', path: '/home/index'},
    // 个人中心
    {name: 'ManageMine', path: '/manage/mine/index', meta: {role: [0, 1]}},
    // 微信公众号绑定
    {name: 'WechatBindSuccess', path: '/manage/system-config/business-config/mp-config/bindingSuccess', meta: {role: [0]}},
    // 租户人员管理
    {name: 'TenantManagement', path: '/manage/base/tenant/index', meta: {role: [0]}},
    // 登录日志查询
    {name: 'LoginLogQuery', path: '/manage/base/log/index', meta: {role: [0]}},
    // 诊所管理
    {name: 'ClinicManagement', path: '/manage/business/clinic/index'},
    // 医生管理
    {name: 'DoctorManagement', path: '/manage/business/doctor/index'},
    // 随访记录
    {name: 'FollowRecord', path: '/manage/business/follow/index'},
    // 会员管理
    {name: 'MemberManagement', path: '/manage/business/member/index', meta: {role: [0, 1]}},
    // 患者管理
    {name: 'PatientManagement', path: '/manage/business/patient/index', meta: {role: [0, 1]}},
    // 专家管理
    {name: 'ManageBusinessExpert', path: '/manage/business/expert/index', meta: {role: [0, 1]}},
    {name: 'MemberRecord', path: '/manage/business/member-record/index', meta: {role: [0, 1]}},
    // 咨询记录管理
    {name: 'FollowUpRecord', path: '/manage/business/follow-up-records/index', meta: {role: [0, 1]}},
    // 病历管理
    {name: 'MedicalRecord', path: '/manage/business/medical-record/index', meta: {role: [0, 1]}},
    /** *********诊断配置start********** */
    // 科室管理
    {name: 'DepartmentManagement', path: '/manage/business/department/index'},
    // 问诊模板管理
    {name: 'InquiryTemplateManagement', path: '/manage/business/inquiry/index'},
    // 诊断结论管理
    {name: 'DiagnosisConclusionManagement', path: '/manage/business/conclusion/index'},
    // 治疗方案管理
    {name: 'ConclusionPrescriptionManagement', path: '/manage/business/conclusion-prescription/index'},
    // 治疗方案管理
    {name: 'ConclusionPrescriptionManagement2', path: '/manage/business/conclusion-prescription-custom/index'},
    {name: 'ClinicalPathwayManagement', path: '/manage/business/clinical-pathway/index'},
    // 协定方管理
    {name: 'StandardizedHerbFormula', path: '/manage/business/prescription/standardized-herb-formula/index'},
    // 代煎订单
    {name: 'DpOrder', path: '/manage/business/dp-order/index'},
    // 科室 | 产品管理
    {name: 'Dept', path: '/manage/business/department-product/index'},
    // 现代医学
    {name: 'ModernMedicine', path: '/manage/business/modern-medicine/index'},
    /** *********诊断配置end********** */
    /** *********中药查询start********** */
    {name: 'HerbLibrary', path: '/manage/business/herb-search/herb-library/index', meta: {role: [0, 1]}},
    {name: 'ClassicPrescription', path: '/manage/business/herb-search/classic-prescription/index', meta: {role: [0, 1]}},
    /** *********中药查询end********** */
    // his数据对接
    {name: 'HisOrganization', path: '/manage/business/his/organization/index', meta: {role: [0]}},
    {name: 'HisMedicine', path: '/manage/business/his/medicine/index', meta: {role: [0]}},
    {name: 'HisPrescriptionParameter', path: '/manage/business/his/prescription-param/index', meta: {role: [0]}},
    {name: 'HisPrescriptionProject', path: '/manage/business/his/prescription-project/index', meta: {role: [0]}},
    // 统计
    {name: 'Overview', path: '/manage/statistics/overview/index', meta: {role: [0]}},
    {name: 'Consilia', path: '/manage/statistics/consilia/index', meta: {role: [0]}},
    {name: 'ManageStatisticsDisease', path: '/manage/statistics/disease/index', meta: {role: [0]}},
    {name: 'ManageStatisticsConclusion', path: '/manage/statistics/conclusion/index', meta: {role: [0]}},
    {name: 'Doctor2PrescriptionStatistics', path: '/manage/statistics/prescription/index', meta: {role: [0]}},
    {name: 'Doctor2PrescriptionMedicineStatistics', path: '/manage/statistics/prescription-medicine/index', meta: {role: [0]}},
    {name: 'ManageSystemConfigGeneralConfig', path: '/manage/system-config/general-config/index', meta: {role: [0]}},
    {name: 'ManageSystemConfigBusinessConfig', path: '/manage/system-config/business-config/index', meta: {role: [0]}},
    {name: 'ManageMedicineOrderPage', path: '/manage/medicine-order/page/index', meta: {role: [0]}},
    {name: 'CustomStock', path: '/manage/business/custom-stock/index', meta: {role: [0]}}
  ]
}]

/**
 * 医生路由
 */
export const doctorRoutes = [
  {
    name: 'DoctorLayout',
    path: '/doctor/layout-new/index',
    children: [
      // 首页
      {name: 'Home', path: '/home/index'},
      {name: 'DoctorHome', path: '/doctor/home/index'},
      // 基本信息
      {name: 'DoctorMine', path: '/doctor/mine/index'},
      // 录入就诊人信息
      {name: 'DoctorDiagnosisStart', path: '/doctor/diagnosis/start/index'},
      // 诊断录入
      // {name: 'DoctorDiagnosisEnter', path: '/doctor/diagnosis/enter/index'},
      // 新的医案录入页面
      // {name: 'DoctorDiagnosisEnter2', path: '/doctor/diagnosis/enter2/index'},
      // 中医疾病的首页
      {name: 'DoctorChineseMedicineHome', path: '/doctor/home/home_chinese_medicine'},
      // 中医疾病的医案录入
      {name: 'DoctorChineseMedicineEnter', path: '/doctor/diagnosis/enter2/index_for_chinese_medicine'},
      // 西医疾病的首页
      {name: 'DoctorWesternMedicineHome', path: '/doctor/home/home_western_medicine'},
      // 西医疾病的医案录入
      {name: 'DoctorWesternMedicineEnter', path: '/doctor/diagnosis/enter2/index_for_western_medicine'},
      // 症状辨证的医案录入
      {name: 'DoctorSymptomDiagnosisEnter', path: '/doctor/diagnosis/enter2/index_for_symptom'},
      // 诊断报告
      {name: 'DoctorDiagnosisReport', path: '/doctor/diagnosis/report/index'},
      // 诊断报告
      {name: 'DoctorDiagnosisReport2', path: '/doctor/diagnosis/report2/index'},
      // 医案记录
      {name: 'DoctorDiagnosisRecord', path: '/doctor/record/index'},
      // 代煎列表
      {name: 'DoctorOrderList', path: '/doctor/order/index'},
      // 咨询记录
      {name: 'DoctorChat', path: '/doctor/chat/index'},
      // 健康辨识
      {name: 'DoctorIllnessEnter', path: '/doctor/illness/enter/index'},
      // 健康报告
      {name: 'MemberRecord', path: '/doctor/member-record/index'},
      // 就诊人信息
      {name: 'MemberInfo', path: '/doctor/member/index'},
      // 分析详情页面
      {name: 'MedicalRecordDetail', path: '/doctor/illness/detail/index'},
      // 健康报告信息详情
      {name: 'IllnessMedicalRecordInfo', path: '/doctor/illness/report/index'},
      // WXTODO: 2022-1-20 测试代码
      {name: 'Test', path: '/doctor/test'}
    ]
  },
  // 医生路由（2025-04 新UI）
  {
    name: 'Doctor2Layout',
    path: '/doctor2/layout/index',
    children: [
      {name: 'Doctor2Home', path: '/doctor2/home/index'},
      // 基本信息
      {name: 'Doctor2Mine', path: '/doctor2/mine/index'},
      // 微信绑定信息
      {name: 'WechatBindSuccess', path: '/doctor2/system-config/business/mp-config/bindingSuccess'},
      // 知症辨症
      {name: 'Doctor2DiagnosisSymptomHome', path: '/doctor2/diagnosis/enter/index_for_symptom'},
      // 知症辨症2
      {name: 'Doctor2DiagnosisSymptomHome2', path: '/doctor2/diagnosis/symptom/index'},
      // 知病辨症
      {name: 'Doctor2DiagnosisMedicineHome', path: '/doctor2/diagnosis/medicine/index'},
      // 门诊
      {name: 'Doctor2DiagnosisHome', path: '/doctor2/diagnosis/medicine2/index'},
      // 诊所管理
      {
        name: 'Doctor2Manage',
        path: '/doctor2/manage/index',
        children: [
          // 药房收费
          {name: 'Doctor2MedicineOrderPage', path: '/doctor2/manage/medicine-order/page/index'},
          // 代煎列表
          {name: 'Doctor2OrderList', path: '/doctor2/manage/order/index'},
          // 收费管理
          {name: 'Doctor2Charge', path: '/doctor2/manage/charge/index'},
          // 发药管理
          {name: 'Doctor2Delivery', path: '/doctor2/manage/delivery/index'},
          // 治疗管理(wyp 2026-03-04)
          {name: 'Doctor2Treat', path: '/doctor2/manage/medicine-treat/index'},
          {name: 'Doctor2TreatLog', path: '/doctor2/manage/medicine-treat/log-index'},
          // 随访管理
          {name: 'Doctor2Follow', path: '/doctor2/manage/follow/index'},
          // 库存管理
          {name: 'Doctor2CustomStock', path: '/doctor2/manage/custom-stock/index'},
          // 患者档案
          {name: 'Doctor2Patient', path: '/doctor2/manage/patient/index'},
          // 会员管理
          {name: 'Doctor2Member', path: '/doctor2/manage/member/index'},
          // 医案记录
          {name: 'Doctor2DiagnosisRecord', path: '/doctor2/record/index'},
          // 预约记录
          {name: 'Doctor2APPT', path: '/doctor2/record/appt/index'},
          // 模板管理
          {name: 'Doctor2TPL', path: '/doctor2/record/tpl/index'}
        ]
      },
      // 咨询记录
      {name: 'Doctor2Chat', path: '/doctor2/chat/index'},
      // 统计
      {
        name: 'Doctor2DiagnosisStatistics',
        path: '/doctor2/statistics/index',
        children: [
          {
            name: 'Doctor2DiagnosisStatisticsOverview',
            path: '/doctor2/statistics/overview/index'
          },
          {
            name: 'Doctor2DiagnosisStatisticsConsilia',
            path: '/doctor2/statistics/consilia/index'
          },
          {
            name: 'Doctor2StatisticsDisease',
            path: '/doctor2/statistics/disease/index'
          },
          {
            name: 'Doctor2StatisticsConclusion',
            path: '/doctor2/statistics/conclusion/index'
          },
          {
            name: 'Doctor2PrescriptionStatistics',
            path: '/doctor2/statistics/prescription/index'
          },
          {
            name: 'Doctor2PrescriptionMedicineStatistics',
            path: '/doctor2/statistics/prescription-medicine/index'
          }
        ]
      },
      // 知识库
      {
        name: 'Doctor2Knowledge',
        path: '/doctor2/knowledge/index',
        children: [
          {
            name: 'Doctor2KnowledgeMedicinalMaterial',
            path: '/doctor2/knowledge/medicinal-material/index'
          },
          {
            name: 'Doctor2KnowledgeClassicMedicalCases',
            path: '/doctor2/knowledge/classic-medical-cases/index'
          },
          {
            name: 'Doctor2KnowledgeFormula',
            path: '/doctor2/knowledge/formula/index'
          },
          {
            name: 'Doctor2KnowledgeModernMedicalData',
            path: '/doctor2/knowledge/modern-medical-data/index'
          },
          {
            name: 'Doctor2KnowledgeClinicalPathway',
            path: '/doctor2/knowledge/clinical-pathway/index'
          },
          {
            name: 'Doctor2KnowledgeClassicMedicalCasesDetail',
            path: '/doctor2/knowledge/classic-medical-cases/detail/index'
          },
          {name: 'Doctor2KnowledgeFormulaDetail', path: '/doctor2/knowledge/formula/detail'},
          {name: 'Doctor2KnowledgeMedicinalMaterialDetail', path: '/doctor2/knowledge/medicinal-material/detail'}
        ]
      },
      // 业务配置
      {name: 'Doctor2Business', path: '/doctor2/system-config/business/index'},
      // 系统管理
      // {
      //   name: 'Doctor2SystemConfig',
      //   path: '/doctor2/system-config/index',
      //   children: [
      //     // 医生管理
      //     {name: 'Doctor2Doctor', path: '/doctor2/system-config/doctor/index'},
      //     // 排班管理
      //     {name: 'Doctor2Sched', path: '/doctor2/system-config/sched/index'},
      //     // 业务配置
      //     {name: 'Doctor2Business', path: '/doctor2/system-config/business/index'}
      //   ]
      // },
      // 西医疾病的医案录入
      {name: 'Doctor2WesternMedicineEnter', path: '/doctor2/diagnosis/enter/index_for_western_medicine'},
      // 中医医案录入
      {name: 'Doctor2ChineseMedicineEnter', path: '/doctor2/diagnosis/enter/index_for_chinese_medicine'},
      // 门诊-西医疾病的医案录入
      {name: 'Doctor2WesternMedicineEnter', path: '/doctor2/diagnosis/enter2/index_for_western_medicine'},
      // 门诊-中医医案录入
      {name: 'Doctor2ChineseMedicineEnter', path: '/doctor2/diagnosis/enter2/index_for_chinese_medicine'},
      // 门诊-知症辨症
      {name: 'Doctor2DiagnosisSymptomHome', path: '/doctor2/diagnosis/enter2/index_for_symptom'},
      // 诊断报告
      {name: 'Doctor2DiagnosisReport', path: '/doctor2/diagnosis/report/index'},
      // 平台版本历史
      {name: 'DoctorPlatformVersionHistory', path: '/doctor2/platform-version/index'},
      // 华医大模型
      {name: 'TcmChatSwitch', path: '/doctor2/tcm/index'}
    ]
  }
]

/**
 * 平台管理员路由
 */
export const platformRoutes = [{
  name: 'Layout',
  path: '/layout/index',
  children: [
    // 首页
    {name: 'Home', path: '/home/index'},
    // 基本信息
    {name: 'PlatformMine', path: '/platform/mine/index'},
    // 平台人员管理
    {name: 'PlatformUser', path: '/platform/user/index'},
    // 租户信息管理
    {name: 'PlatformTenant', path: '/platform/tenant/index'},
    // 药材库
    {name: 'MedicineChinese', path: '/platform/medicine-chinese/index'},
    // 经典方
    {name: 'MedicinePrescription', path: '/platform/medicine-prescription/index'},
    // 用户管理  租户&医生
    {name: 'UserManage', path: '/platform/user/manage/index'},
    {name: 'Setting', path: '/platform/setting/index'},
    // 舌象特征
    {name: 'TongueCharacter', path: '/platform/tongue-character/index'},
    // 体质证型配置
    {name: 'ConstitutionPatternConfig', path: '/platform/constitution-pattern-config/index'},
    // 医案记录
    {name: 'PlatformMedicalRecord', path: '/platform/medical-record/index'},
    // 健康报告 2025/5/16 去除
    // {name: 'PlatformIllnessMedicalRecord', path: '/platform/illness-medical-record/index'},
    // 特征变化
    {name: 'CharacterChange', path: '/platform/character/change'},
    // 问诊分词词库
    {name: 'HanlpParticipleLexicon', path: '/platform/hanlp/index'},
    // 脉诊设备库
    {name: 'PulseDeviceLibrary', path: '/platform/pulse/index'},
    // 脉诊设备库
    {name: 'PulseDeviceLibrary', path: '/platform/pulse/index'},
    // 操作日志
    {name: 'OperationLog', path: '/platform/log/index'},
    // 问题反馈
    {name: 'ProblemFeedback', path: '/platform/problem-feedback/index'},
    // 平台版本
    {name: 'PlatformVersion', path: '/platform/platform-version/index'},
    // 个性化治疗方案申请
    {name: 'OperationLog', path: '/platform/custom-prescription-agreement/index'},
    // 经典医案
    {name: 'ClassicMedicalCasePage', path: '/platform/classic-medical-case/page/index'},
    {name: 'FamousDoctorLibPage', path: '/platform/famous-doctor-lib/page/index'},
    {name: 'MakeImage', path: '/platform/medicine-prescription/makeImage'},
    {name: 'MedicineOrderPage', path: '/platform/medicine-order/page/index'},
    {name: 'SmsConfig', path: '/platform/sms/index'},
    // icd疾病编码库
    {name: 'icd', path: '/platform/icd-disease-lib/index'},
    {name: 'TenantConfig', path: '/platform/tenant-config/index'}
  ]
}]



// WEBPACK FOOTER //
// ./src/router/routes.js